export default "__VITE_ASSET__Bd1o8RQg__"